import apiURL from "../config/environment";
import {monthMap} from "../utils"

export const getScatsData = async () => {
    const token = JSON.parse(localStorage.getItem("userInfo"))?.token;
    const response = await fetch(apiURL + "dashboard/data/scats", {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    });
    if (!response.ok) {
        throw new Error("Network response was not ok");
    }
    const data = await response.json();

    const cyearMonthlyPedButtonsUptime = [];
    const cyearMonthlyXuUptime = [];
    const cyearMonthlyCuUptime = [];
    const cyearMonthlyDetectorUptime = [];
    const cyearMonthlySignalUptime = [];
    const cyearMonthlyCongestion = [];


    const lyearMonthlyPedButtonsUptime = [];
    const lyearMonthlyXuUptime = [];
    const lyearMonthlyCuUptime = [];
    const lyearMonthlyDetectorUptime = [];
    const lyearMonthlySignalUptime = [];
    const lyearMonthlyCongestion = [];
    const scatsData = data.monthly;

    // TODO: simplify the following dates
    const now = new Date();
    const cyearEarliestYear = now.getMonth() === 0 ? now.getFullYear() - 2 : now.getFullYear() - 1;
    const endRangeYear = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear();
    const lastMonth = now.getMonth() === 0 ? 11 : now.getMonth() - 1;
    const lyearStartRange = new Date(now.getFullYear() - 1, now.getMonth(), 1);
    const endRange = new Date(endRangeYear, lastMonth, 1);

    for (let i = 0; i < scatsData.year.length; i++) {
        if ((scatsData.year[i] === lyearStartRange.getFullYear() && scatsData.month[i] >= lyearStartRange.getMonth() + 1) ||
            (scatsData.year[i] === endRange.getFullYear() && scatsData.month[i] <= endRange.getMonth() + 1)
        ) {
            lyearMonthlyDetectorUptime.push({
                category: `${scatsData.year[i]}`,
                xAxis: monthMap.get(scatsData.month[i]),
                density: "Hours Down",
                yAxis: scatsData.dhd[i]
            })
            lyearMonthlyDetectorUptime.push({
                category: `${scatsData.year[i]}`,
                xAxis: monthMap.get(scatsData.month[i]),
                density: "Uptime",
                yAxis: scatsData.du[i],
            })

            lyearMonthlyPedButtonsUptime.push({
                category: `${scatsData.year[i]}`,
                xAxis: monthMap.get(scatsData.month[i]),
                density: "Hours Down",
                yAxis: scatsData.pbhd[i]
            })
            lyearMonthlyPedButtonsUptime.push({
                category: `${scatsData.year[i]}`,
                xAxis: monthMap.get(scatsData.month[i]),
                density: "Uptime",
                yAxis: scatsData.pbu[i],
            })

            lyearMonthlySignalUptime.push({
                category: `${scatsData.year[i]}`,
                xAxis: monthMap.get(scatsData.month[i]),
                density: "Hours Flashing",
                yAxis: scatsData.shd[i]
            })
            lyearMonthlySignalUptime.push({
                category: `${scatsData.year[i]}`,
                xAxis: monthMap.get(scatsData.month[i]),
                density: "Uptime",
                yAxis: scatsData.su[i],
            })
            lyearMonthlyXuUptime.push({
                category: `${scatsData.year[i]}`,
                xAxis: monthMap.get(scatsData.month[i]),
                density: "Hours Down",
                yAxis: scatsData.xuhd[i]
            })
            lyearMonthlyXuUptime.push({
                category: `${scatsData.year[i]}`,
                xAxis: monthMap.get(scatsData.month[i]),
                density: "Uptime",
                yAxis: scatsData.xuu[i]
            })


            lyearMonthlyCuUptime.push({
                category: `${scatsData.year[i]}`,
                xAxis: monthMap.get(scatsData.month[i]),
                density: "Hours Down",
                yAxis: scatsData.cuhd[i]
            })
            lyearMonthlyCuUptime.push({
                category: `${scatsData.year[i]}`,
                xAxis: monthMap.get(scatsData.month[i]),
                density: "Uptime",
                yAxis: scatsData.cuu[i]
            })

            lyearMonthlyCongestion.push({
                year: scatsData.year[i],
                month: scatsData.month[i],
                avg_congested: scatsData.mc[i],
                cs_15_30: scatsData.mc_15_30[i],
                cs_30_60: scatsData.mc_30_60[i],
                cs_60_plus: scatsData.mc_60_inf[i],
            })
        }

        if ((scatsData.year[i] >= cyearEarliestYear) &&
            !(scatsData.year[i] === endRange.getFullYear() && scatsData.month[i] > endRange.getMonth() + 1)
        ) {
            cyearMonthlyDetectorUptime.push({
                category: `${scatsData.year[i]}`,
                xAxis: monthMap.get(scatsData.month[i]),
                density: "Hours Down",
                yAxis: scatsData.dhd[i]
            })
            cyearMonthlyDetectorUptime.push({
                category: `${scatsData.year[i]}`,
                xAxis: monthMap.get(scatsData.month[i]),
                density: "Uptime",
                yAxis: scatsData.du[i],
            })

            cyearMonthlyPedButtonsUptime.push({
                category: `${scatsData.year[i]}`,
                xAxis: monthMap.get(scatsData.month[i]),
                density: "Hours Down",
                yAxis: scatsData.pbhd[i]
            })
            cyearMonthlyPedButtonsUptime.push({
                category: `${scatsData.year[i]}`,
                xAxis: monthMap.get(scatsData.month[i]),
                density: "Uptime",
                yAxis: scatsData.pbu[i],
            })

            cyearMonthlySignalUptime.push({
                category: `${scatsData.year[i]}`,
                xAxis: monthMap.get(scatsData.month[i]),
                density: "Hours Flashing",
                yAxis: scatsData.shd[i]
            })
            cyearMonthlySignalUptime.push({
                category: `${scatsData.year[i]}`,
                xAxis: monthMap.get(scatsData.month[i]),
                density: "Uptime",
                yAxis: scatsData.su[i],
            })

            cyearMonthlyXuUptime.push({
                category: `${scatsData.year[i]}`,
                xAxis: monthMap.get(scatsData.month[i]),
                density: "Hours Down",
                yAxis: scatsData.xuhd[i]
            })
            cyearMonthlyXuUptime.push({
                category: `${scatsData.year[i]}`,
                xAxis: monthMap.get(scatsData.month[i]),
                density: "Uptime",
                yAxis: scatsData.xuu[i]
            })

            cyearMonthlyCuUptime.push({
                category: `${scatsData.year[i]}`,
                xAxis: monthMap.get(scatsData.month[i]),
                density: "Hours Down",
                yAxis: scatsData.cuhd[i]
            })
            cyearMonthlyCuUptime.push({
                category: `${scatsData.year[i]}`,
                xAxis: monthMap.get(scatsData.month[i]),
                density: "Uptime",
                yAxis: scatsData.cuu[i]
            })

            cyearMonthlyCongestion.push({
                year: scatsData.year[i],
                month: scatsData.month[i],
                avg_congested: scatsData.mc[i],
                cs_15_30: scatsData.mc_15_30[i],
                cs_30_60: scatsData.mc_30_60[i],
                cs_60_plus: scatsData.mc_60_inf[i],
            })
        }
    }

    return {
        min: {
            chart: {
                lyear: lyearMonthlyCongestion,
                cyear: cyearMonthlyCongestion
            },
            stats: {
                uptime: data.stats.mc,
                hoursDown: data.stats.mc,
            },
            ranks: {
                ytd: data.ranks.mc_ytd ? data.ranks.mc_ytd.k.map((location, idx) => {
                    return {
                        location,
                        value: data.ranks.mc_ytd.v[idx]
                    }
                }) : [],
                l30d: data.ranks.mc_l30d ? data.ranks.mc_l30d.k.map((location, idx) => {
                    return {
                        location,
                        value: data.ranks.mc_l30d.v[idx]
                    }
                }) : [],
            }
        },
        "detector-uptime": {
            chart: {
                lyear: lyearMonthlyDetectorUptime,
                cyear: cyearMonthlyDetectorUptime,
            },
            stats: {
                uptime: data.stats.du,
                hoursDown: data.stats.dhd,
            },
            ranks: {
                ytd: data.ranks.dhd_ytd ? data.ranks.dhd_ytd.k.map((location, idx) => {
                    return {
                        location,
                        value: data.ranks.dhd_ytd.v[idx]
                    }
                }) : [],
                l30d: data.ranks.dhd_l30d ? data.ranks.dhd_l30d.k.map((location, idx) => {
                    return {
                        location,
                        value: data.ranks.dhd_l30d.v[idx]
                    }
                }) : [],
            }
        },
        "ped-button-uptime": {
            chart: {
                lyear: lyearMonthlyPedButtonsUptime,
                cyear: cyearMonthlyPedButtonsUptime
            },
            stats: {
                uptime: data.stats.pbu,
                hoursDown: data.stats.pbhd,
            },
            ranks: {
                ytd: data.ranks.pbhd_ytd ? data.ranks.pbhd_ytd.k.map((location, idx) => {
                    return {
                        location,
                        value: data.ranks.pbhd_ytd.v[idx]
                    }
                }) : [],
                l30d: data.ranks.pbhd_l30d ? data.ranks.pbhd_l30d.k.map((location, idx) => {
                    return {
                        location,
                        value: data.ranks.pbhd_l30d.v[idx]
                    }
                }) : [],
            }
        },
        "signal-uptime": {
            chart: {
                lyear: lyearMonthlySignalUptime,
                cyear: cyearMonthlySignalUptime,
            },
            stats: {
                uptime: data.stats.su,
                hoursDown: data.stats.shd,
            },
            ranks: {
                ytd: data.ranks.shd_ytd ? data.ranks.shd_ytd.k.map((location, idx) => {
                    return {
                        location,
                        value: data.ranks.shd_ytd.v[idx]
                    }
                }) : [],
                l30d: data.ranks.shd_l30d ? data.ranks.shd_l30d.k.map((location, idx) => {
                    return {
                        location,
                        value: data.ranks.shd_l30d.v[idx]
                    }
                }) : [],

            }
        },
        "power-uptime": {
            chart: {
                lyear: lyearMonthlyXuUptime,
                cyear: cyearMonthlyXuUptime
            },
            stats: {
                uptime: data.stats.xuu,
                hoursDown: data.stats.xuhd,
            },
            ranks: {
                ytd: data.ranks.xuhd_ytd ? data.ranks.xuhd_ytd.k.map((location, idx) => {
                    return {
                        location,
                        value: data.ranks.xuhd_ytd.v[idx]
                    }
                }) : [],
                l30d: data.ranks.xuhd_l30d ? data.ranks.xuhd_l30d.k.map((location, idx) => {
                    return {
                        location,
                        value: data.ranks.xuhd_l30d.v[idx]
                    }
                }) : [],
            }
        },
        "comms-uptime": {
            chart: {
                lyear: lyearMonthlyCuUptime,
                cyear: cyearMonthlyCuUptime
            },
            stats: {
                uptime: data.stats.cuu,
                hoursDown: data.stats.cuhd,
            },
            ranks: {
                ytd: data.ranks.cuhd_ytd ? data.ranks.cuhd_ytd.k.map((location, idx) => {
                    return {
                        location,
                        value: data.ranks.cuhd_ytd.v[idx]
                    }
                }) : [],
                l30d: data.ranks.cuhd_l30d ? data.ranks.cuhd_l30d.k.map((location, idx) => {
                    return {
                        location,
                        value: data.ranks.cuhd_l30d.v[idx]
                    }
                }) : [],
            }
        },
    }
}

